import { useEffect, useState } from 'react';

export const useDeviceCategory = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: width <= 768,
    isTablet: width > 768 && width <= 1024,
    isMobileAndTablet: width <= 1024,
    isMobileAndTabletSmallLaptop: width <= 1400,
    isDesktop: width > 1024,
    isSmallMobile: width <= 540,
    isDesktopWithZoom100: width > 900,
    isLandscapeForMobile: width <= 940 && height <= 440,
    isMobileAndBigTablet: width <= 1220,
    isTablets: width > 768 && width < 1024,
    isMobileInvoicePdf: width <= 768,
    isTabletInvoicePdf: width > 1000 && width < 1025,
    isMobileAndBigTabletInvoicePdf: width > 1025 && width < 1220,
    isMobileAndTabletInvoicePdf: width > 767 && width < 1000,
  };
};
